import React from 'react';
import { components } from 'react-select';
import { CaretSolidIcon } from '@parchment/icons';
export class DropdownIndicator extends React.Component {
  static get propTypes() {
    return {
      ...components.DropdownIndicator.propTypes
    };
  }
  static get defaultProps() {
    return {
      ...components.DropdownIndicator.defaultProps
    };
  }
  renderCaret() {
    const {
      menuIsOpen
    } = this.props.selectProps;
    return menuIsOpen ? /*#__PURE__*/React.createElement(CaretSolidIcon, {
      rotate: "180deg"
    }) : /*#__PURE__*/React.createElement(CaretSolidIcon, null);
  }
  render() {
    return /*#__PURE__*/React.createElement(components.DropdownIndicator, this.props, this.renderCaret());
  }
}